<template>
  <div>
    <div class="barcode-scanner-container" v-if="isMediaStreamAPISupported">
      <div class="panel settings-container">
        <div class="panel-body text-left">
          <b class="glyphicon glyphicon-cog float-right" @click="showSettings = !showSettings"></b>
          <div class="panel panel-default c4-bg" v-show="showSettings">
            <div class="panel-body">
              <b @click="showAvailableDevices = !showAvailableDevices">Cameras <sub class="glyphicon glyphicon-expand"></sub></b><br />
              <p v-show="showAvailableDevices">
                <span class="settings-item" v-for="dv in availableDevices">
                  <input type="radio" id="webcan-{{dv.deviceId}}" :value="dv.deviceId" v-model="selectedDeviceId">
                  <label for="webcan-{{dv.deviceId}}">{{dv.label}}</label>
                </span>
              </p>
              <b @click="showAvailableBarcodeReaders = !showAvailableBarcodeReaders">Barcode Types <sub class="glyphicon glyphicon-expand"></sub></b><br />
              <p v-show="showAvailableBarcodeReaders">
                <span class="settings-item" v-for="reader in availableBarcodeReaders">
                  <input type="checkbox" :id="'barcode-type-' + reader.value" :value="reader.value" v-model="selectedBarcodeReaders">
                  <label :for="'barcode-type-' + reader.value" style="display:inline;">{{reader.name}}</label>
                </span>
              </p>
              <b>Num Of Workers(1-{{maxNumOfWorkers}}): </b> <input type="text" v-model="numOfWorkers" /><br />
              <b>Adjustment Rate(1-99): </b> <input type="text" v-model="adjustmentRate" />
            </div>
          </div>
          <button class="btn c1-bg" @click="clickScanButton">{{scanButtonMessage}}</button>
          <div>
            <b>Detected barcode:</b> {{detected}}
          </div>
        </div>
      </div>
      <div>
        <barcode-scanner :start-scan.sync="startScan"
                         :device-id="selectedDeviceId"
                         :reader-types="selectedBarcodeReaders"
                         :reader-size="readerSize"
                         :adjustment-rate="adjustmentRate"
                         :num-of-workers="numOfWorkers"
                         @get-detected-code="getDetectedCode($event)"
                         v-show="startScan"></barcode-scanner>
      </div>
    </div>
    <div v-else>
      <div class="panel">
        <div class="panel-body">
          {{mediaNotSupportedMessage}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BarcodeScanner from "./QuaggaJsBarcodeScanner";

  export default {
    name: "QuaggaJsBarcodeReader",
    components: {
      BarcodeScanner
    },
    props: {
      startScan: Boolean,
    },
    data() {
      return {
        detected: '',
        scanButtonMessage: '',
        showSettings: false,
        isMediaStreamAPISupported: false,
        mediaNotSupportedMessage: 'Webcam is not supported!',
        selectedDeviceId: '',
        showAvailableDevices: false,
        availableDevices: [],
        selectedBarcodeReaders: ['code_128_reader', 'code_39_reader', 'code_39_vin_reader', 'code_93_reader',
          'codabar_reader', 'ean_reader', 'ean_8_reader',
          'upc_reader', 'upc_e_reader',
          'i2of5_reader', '2of5_reader'],
        showAvailableBarcodeReaders: false,
        availableBarcodeReaders: [
          { name: "Code128", value: "code_128_reader" },
          { name: "Code39", value: "code_39_reader" },
          { name: "Code39VIN", value: "code_39_vin_reader" },
          { name: "Code93", value: "code_93_reader" },
          { name: "Codabar", value: "codabar_reader" },
          { name: "EAN", value: "ean_reader" },
          { name: "EAN8", value: "ean_8_reader" },
          { name: "UPC", value: "upc_reader" },
          { name: "UPC E", value: "upc_e_reader" },
          { name: "I2of5", value: "i2of5_reader" },
          { name: "2of5", value: "2of5_reader" },
        ],
        readerSize: null,
        adjustmentRate: 90,
        numOfWorkers: 1,
      };
    },
    computed: {
      maxNumOfWorkers: function () {
        return navigator.hardwareConcurrency
      }
    },
    created() {
      //alert("created");
      window.addEventListener("resize", this.windowResizeHandler);
    },
    mounted: function () {
      //alert("mounted");
      this.resizeBarcodeReader();
      this.scanButtonMessage = !this.startScan ? 'Start Scan' : 'Stop Scan';
      let count = 1;
      const lastSelectedCam = this.$cookies.get('lastSelectedCam');
      const lastSelectedBarcodeReaders = JSON.parse(this.$cookies.get('lastSelectedBarcodeReaders')); //selectedBarcodeReaders
      const lastAdjustmentRate = this.$cookies.get('lastAdjustmentRate');
      const lastNumOfWorkers = this.$cookies.get('lastNumOfWorkers');

      if (lastSelectedBarcodeReaders && lastSelectedBarcodeReaders.length > 0)
        this.selectedBarcodeReaders = lastSelectedBarcodeReaders.filter(v => this.availableBarcodeReaders.some(x => x.value === v));
      if (lastAdjustmentRate) this.adjustmentRate = lastAdjustmentRate;
      if (lastNumOfWorkers) this.numOfWorkers = lastNumOfWorkers;

      navigator.mediaDevices.getUserMedia({ video: true })
        .then(() => {
          navigator.mediaDevices.enumerateDevices()
            .then((devices) => {
              devices.forEach((device) => {
                //alert(device.kind + "  " + device.label);
                if (device.kind == "videoinput") {  // && device.label.toLowerCase().match(/back/) !== null
                  const tempDevice = { label: 'cam-' + count, deviceId: device.deviceId };
                  this.availableDevices.push(tempDevice);
                  this.isMediaStreamAPISupported = true;

                  if (lastSelectedCam === tempDevice.deviceId) this.selectedDeviceId = tempDevice.deviceId;
                  count++;
                }
              });
            })
            .catch(function (err) {
              //alert(err);
              return console.log(err);
            });
        })
        .catch(function (err) {
          //alert(err);
          return console.log(err);
        });
    },
    destroyed() {
      window.removeEventListener("resize", this.windowResizeHandler);
    },
    watch: {
      startScan: function (newValue, oldValue) {
        this.scanButtonMessage = !newValue ? 'Start Scan' : 'Stop Scan';
        this.$emit('update:startScan', newValue);
      },
      selectedDeviceId: function (newValue, oldValue) {
        this.$cookies.set('lastSelectedCam', newValue);
      },
      selectedBarcodeReaders: function (newValue, oldValue) {
        this.$cookies.set('lastSelectedBarcodeReaders', JSON.stringify(newValue));
      },
      adjustmentRate: function (newValue, oldValue) {
        this.$cookies.set('lastAdjustmentRate', newValue);
      },
      numOfWorkers: function (newValue, oldValue) {
        this.$cookies.set('lastNumOfWorkers', newValue);
      },
    },
    methods: {
      clickScanButton() {
        this.startScan = !this.startScan;
      },
      windowResizeHandler(e) {
        this.resizeBarcodeReader();
      },
      resizeBarcodeReader() {
        const readerWidth = window.innerWidth >= 1024 ? 900 : (window.innerWidth - 20);
        const readerHeight = window.innerHeight - 20;
        this.readerSize =
        {
          width: readerWidth,
          height: readerHeight
        };
      },
      getDetectedCode(detectedCode) {
        this.detected = detectedCode;
        this.$emit('barcode-detected', detectedCode);
      }
    },
  };
</script>

<style scoped>
  .barcode-scanner-container {
    position: relative;
    height: 90vh;
  }

  .settings-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2040;
    background-color: rgba(0,0,0,0);
  }

    .settings-container .settings-item {
      display: inline-block;
      padding-right: 10px;
    }

      .settings-container .settings-item label {
        display: inline;
      }
</style>



// WEBPACK FOOTER //
// EcomCore/Components/InputDevices/QuaggaJsBarcodeReader.vue